import throttle from 'lodash.throttle';
import EventEmitter from 'events';

export default class Scroller extends EventEmitter {

  /**
   * Constructor
   * 
   * @param {Object} options List of options
   */
  constructor(options = {}) {
    super();

    /**
     * Whether the scroller should be spitting out debug data in console or not.
     */
    this.debug = process.env.NODE_ENV !== 'production' ? true : options.debug || false;

    /**
     * How often to fire the 'scroll' event.
     */
    this.throttle = options.throttle || 150;

    /**
     * Reference to our throttled tick function.
     */
    this._throttleTickFunction = throttle(() => this.tick(), this.throttle);

    // If option is not explicitly false, we start.
    if (options.tick_autostart !== false) this.startTicking();
  }
  
  /**
   * Wrapper function for console.log. Used together with debug.
   *
   * @param  {...any} args
   */
  log(...args) {
    if (this.debug) {
      console.log('Scroller', '-', ...args);
    }
  }

  /**
   * Wrapper function for console.error.
   *
   * @param  {...any} args
   */
  error(...args) {
    console.error('Scroller', '-', ...args);
  }

  /**
   * Start the scroll ticker.
   */
  startTicking() {
    window.addEventListener('scroll', this._throttleTickFunction);
  }

  /**
   * Stop the scroll ticker.
   */
  stopTicking() {
    window.removeEventListener('scroll', this._throttleTickFunction);
  }
  
  /**
   * Helper function for getting current scroll position. Takes 'top' (default), 'mid' and 'bot'.
   *
   * @param {String} pos
   */
  scrollPosition(pos = 'top') {
    if (pos == 'top') {
      return window.scrollY;
    }
    if (pos == 'mid') {
      return window.scrollY + window.innerHeight / 2;
    }
    if (pos == 'bot') {
      return window.scrollY + window.innerHeight;
    }
  }

  /**
   * Triggers a scroll-trick.
   */
  tick() {
    this.log("TICK")
    this.emit('tick');
  }
}